import { render } from "./Sidebar.vue?vue&type=template&id=63f2d232&scoped=true&lang=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=63f2d232&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-63f2d232"

export default script